import { inject as service } from '@ember/service';
import DeliveriesController from 'cio/controllers/deliveries';
import { LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL, LAST_7_DAYS_RANGE_PRESET_LOCAL_FULL } from 'cio/utils/date-picker';
import AuthService from 'cio/services/auth';

export default class DraftsController extends DeliveriesController {
  filterQueryParams = ['campaign', 'action', 'recipient'];
  queryParams = ['actionType', 'campaign', 'action', 'recipient', 'startTs', 'endTs'];
  fetchDrafted = true;
  detailRoute = 'draft.index';
  icon = 'draft';
  drafted = true;

  dateRangePresets = [LAST_7_DAYS_RANGE_PRESET_LOCAL_FULL, LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL];

  @service auth!: AuthService;

  get hasReadOnlyPermission() {
    return !this.auth.hasPermission('journeys/messages/send');
  }
}
